import React, { useEffect, useState } from 'react';

const Flip2 = ({ question, answer }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [islap, setislap] = useState(true);

    const screenWidth = window.innerWidth;


    useEffect(() => {
        if (screenWidth <= 500) {
            setislap(false)
        } else {
            setislap(true);
        }
    })

    return (
        <>
            {
                islap
                    ?
                    <div
                        className="flip-card2"
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <div div className={`flip-card2-inner ${isHovered ? 'flipped2' : ''}`}>
                            <div className="flip-card2-front">
                                <h3>{question}</h3>
                            </div>
                            <div className="flip-card2-back">
                                <p>{answer}</p>
                            </div>
                        </div >
                    </div >
                    :
                    <div
                        className="flip-card3"
                        onMouseEnter={() => setIsHovered(true)}
                        onMouseLeave={() => setIsHovered(false)}
                    >
                        <div div className={`flip-card3-inner ${isHovered ? 'flipped3' : ''}`}>
                            <div className="flip-card3-front">
                                <h3>{question}</h3>
                            </div>
                            <div className="flip-card3-back">
                                <p>{answer}</p>
                            </div>
                        </div >
                    </div >
            }

        </>

    );
};

export default Flip2;
